/* @ngInject */
function localStorageService ($window) {
  const service = {
    set,
    get,
    del
  }
  return service

  function set (name, value) {
    $window.localStorage.setItem(name, value)
  }

  function get (name) {
    return $window.localStorage.getItem(name)
  }

  function del (name) {
    $window.localStorage.removeItem(name)
  }
}

export { localStorageService }
